@if (flatrates && flatrates.length > 0) {
  <div class="d-flex flex-column h-100">
    <app-content-header [backLabel]="'app_back'" [historyBack]="false" (backEvent)="onBack()" [headline]="'tariff_choose_headline' | i18next"></app-content-header>
    <div class="row d-flex mt-2 justify-content-center">
      @for (flat of filteredFlatrates(); track flat) {
        <div class="mx-3">
          <app-base-price-card
            [name]="flat.displayName"
            [product]="flat.name"
            [price]="+flat.listPrice"
            [isSelected]="flat.name === this.currentPlan"
            [buttonText]="'app_select' | i18next"
            (selected)="onTariffSelected($event)">
            @if (flat.zones.length > 0) {
              <div class="container">
                <div class="h3 red">{{ 'tariff_including_minutes' | i18next }}</div>
                <div class="d-flex justify-content-center features">
                  <div class="d-flex flex-column align-items-start">
                    @for (zone of flat.zones; track zone) {
                      <div>
                        <div class="d-flex align-items-center">
                          <div>
                            <span class="font-weight-bold red mr-1">{{ zone.freeMinutes }}</span>
                            <span>{{ getZoneTranslationKey(zone.name) | i18next }}</span>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </app-base-price-card>
        </div>
      }
    </div>
    <div class="row mt-5">
      <div class="mx-auto">
        <div innerHTML="{{ 'download_complete_pricelist' | i18next:{tenant: countryTranslationCode} }}"></div>
      </div>
    </div>
    <div class="ml-auto mt-auto p-3 small">{{ 'vat_not_included' | i18next }}</div>
  </div>
}
